export enum AlarmFlagsEnum {
    None = 0x00000000,
    OverThirdBandWithdrawal = 0x00000001,
    EmptyInAlarmTimeBand = 0x00000002,
    commandCA = 0x00000004,
    DoorOpen = 0x00000008,
    WriteParameters = 0x00000010,
}
